export const GlobeIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
		<path
			fill="#06519E"
			d="M11 22C4.935 22 0 17.07 0 11S4.935 0 11 0s11 4.93 11 11-4.935 11-11 11Zm-2.275-2.29c-3.552-.93-6.256-3.98-6.67-7.71H6.05c.224 2.76 1.148 5.41 2.675 7.71Zm4.55 0c3.552-.93 6.256-3.98 6.67-7.71h-3.997c-.229 2.78-1.152 5.42-2.673 7.71ZM15.95 10h3.995c-.414-3.73-3.118-6.78-6.67-7.71 1.527 2.3 2.451 4.95 2.675 7.71ZM8.725 2.29C5.173 3.22 2.47 6.27 2.055 10h3.998c.229-2.78 1.151-5.42 2.672-7.71ZM8.058 10C8.309 7.29 9.33 4.7 11 2.55c1.677 2.16 2.7 4.75 2.945 7.45H8.058Zm-.003 2h5.888c-.251 2.71-1.272 5.3-2.943 7.45C9.324 17.29 8.301 14.7 8.055 12Z"
			fillRule="evenodd"
		/>
	</svg>
);
